import { ForbidCircleIcon } from '@vlabs/icons';
import { regexp } from '@vlabs/uikit';
import { Button } from '@vlabs/uikit/components/controls/button';
import { Input } from '@vlabs/uikit/components/controls/input';
import { useForm } from 'react-hook-form';

import { useLoginFormTranslation } from './i18n';
import st from './LoginForm.module.sass';

export interface LoginFormValues {
  login: string;
  password: string;
}

const defaultValues: LoginFormValues = {
  login: '',
  password: '',
};

interface LoginFormProps {
  onSubmit: (values: LoginFormValues) => void;
  error?: React.ReactNode;
}

function LoginForm({
  onSubmit,
  error = undefined,
}: LoginFormProps): React.JSX.Element {
  const { t } = useLoginFormTranslation();
  const { register, handleSubmit, formState: { errors } } = useForm<LoginFormValues>({
    defaultValues,
  });

  return (
    <form
      className={st.Root}
      onSubmit={handleSubmit(onSubmit)}
    >
      {!!error && (
        <div className={st.Error}>
          <ForbidCircleIcon />
          {error}
        </div>
      )}

      <div className={st.Input}>
        <Input
          className={st.Input}
          data-testid="login"
          errors={errors}
          id="login"
          placeholder={t('login.placeholder')}
          {...register('login', {
            required: t('login.required'),
            pattern: {
              value: regexp.email,
              message: t('login.regex'),
            },
          })}
        />
      </div>

      <div className={st.Input}>
        <Input
          className={st.Input}
          data-testid="password"
          errors={errors}
          id="password"
          placeholder={t('password.placeholder')}
          type="password"
          {...register('password', {
            required: t('login.required'),
          })}
        />
      </div>

      <div className={st.Actions}>
        <Button
          className={st.Submit}
          data-testid="submit"
          type="submit"
        >
          {t('submit')}
        </Button>
      </div>
    </form>
  );
}

export { LoginForm };
